/**
 * Resolve an offer's auto-reject explanation in the active language.
 *
 * Backend writes both `auto_reject_code` (machine-readable, e.g.
 * `"below_listing_min"`) + `auto_reject_params` (numeric thresholds) AND
 * the legacy free-text `auto_reject_reason` ("Mindestvorschlag … € (…)").
 * We prefer the code so the UI can localise; fall back to the German
 * legacy string for old rows.
 */
import i18n from "../i18n";

const FORMATTERS = {
    de: new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 }),
    en: new Intl.NumberFormat("en-GB", { maximumFractionDigits: 0 }),
};

function fmtPrice(value) {
    if (value === null || value === undefined || Number.isNaN(Number(value))) return "";
    const lang = i18n.resolvedLanguage === "en" ? "en" : "de";
    return `${FORMATTERS[lang].format(Number(value))} €`;
}

export function formatAutoReject(code, params, reason) {
    const t = i18n.t.bind(i18n);
    if (code === "below_listing_min" && params?.threshold !== undefined) {
        return t("offers.auto_reject_below_listing_min", { threshold: fmtPrice(params.threshold) });
    }
    if (code === "below_seller_pct" && params?.threshold !== undefined && params?.pct !== undefined) {
        return t("offers.auto_reject_below_seller_pct", {
            threshold: fmtPrice(params.threshold),
            pct: params.pct,
        });
    }
    // Fallback for legacy rows without a code → show the original reason string.
    return reason || "";
}
